import React from 'react';
import { Col, Container, Row } from 'reactstrap';


const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row className="align-items-center gy-2">
                        <Col sm={4}>
                            {new Date().getFullYear()} © BestStay.
                        </Col>
                       
                       
                        <Col sm={4}>
                            <div className="text-sm-end d-none d-sm-block">
                                Design & Develop by Hospitality Group
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;
